// extracted by mini-css-extract-plugin
module.exports = {"Host":"Tag_Host_3gKtQ","Label":"Tag_Label_3rXVh","Remove":"Tag_Remove_1tgvF"};